var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTodayThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#757c95",
    r: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.5084 18.137c.9635 0 1.7446-.7811 1.7446-1.7446s-.7811-1.7446-1.7446-1.7446-1.74454.7811-1.74454 1.7446.78104 1.7446 1.74454 1.7446z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12.6424 6.97176c0-.43357-.3515-.78505-.7851-.78505-.4335 0-.785.35148-.785.78505v1.30842h-2.18073c-1.49342 0-2.70407 1.21066-2.70407 2.70412v11.5141c0 1.4934 1.21065 2.7041 2.70407 2.7041h14.30543c1.4934 0 2.7041-1.2107 2.7041-2.7041v-11.5141c0-1.49346-1.2107-2.70412-2.7041-2.70412h-2.1807v-1.30842c0-.43357-.3515-.78505-.7851-.78505-.4335 0-.785.35148-.785.78505v1.30842h-6.8038zm-4.88479 6.97824v8.3739c0 .7226.5858 1.3084 1.30842 1.3084h13.95647c.7227 0 1.3085-.5858 1.3085-1.3084v-8.3739c0-.7226-.5858-1.3084-1.3085-1.3084h-13.95647c-.72262 0-1.30842.5858-1.30842 1.3084z",
    fillRule: "evenodd"
  }))));
}

export default SvgTodayThumb;